import React from 'react';
import { useSafeNavigation, useSafeRouter } from '@sg/garnish';

import { useIsExpoRouterEnabled } from '@order/shared/hooks';

// ─────────────────────────────────────────────────────────────────────────────

export const useOrderStatusNavigation = () => {
  const isExpoRouterEnabled = useIsExpoRouterEnabled();
  const navigation = useSafeNavigation();
  const router = useSafeRouter();

  // ─────────────────────────────────────────────────────────────────────

  const navigateToOrderStatusScreen = React.useCallback(
    (orderId: string) => {
      if (isExpoRouterEnabled) {
        router?.navigate({
          pathname: '/order-status/[orderId]',
          params: { orderId },
        });
        return;
      }

      navigation?.navigate('Modal', {
        screen: 'OrderStatus',
        params: { orderId },
      });
    },
    [isExpoRouterEnabled, router, navigation],
  );

  const navigateToRateOrderScreen = React.useCallback(
    (orderId: string) => {
      if (isExpoRouterEnabled) {
        router?.navigate({
          pathname: '/feedback/[orderId]',
          params: { orderId },
        });
        return;
      }

      navigation?.navigate('Modal', {
        screen: 'RateOrder',
        params: { orderId },
      });
    },
    [isExpoRouterEnabled, router, navigation],
  );

  // ─────────────────────────────────────────────────────────────────────

  return {
    navigateToOrderStatusScreen,
    navigateToRateOrderScreen,
  };
};
